<template>
    <a :href="hrefRes" @click="click" v-if="isLink" :target="target" class="xx-link">
        <el-button :type="type" :disabled="disabled" :size="size" v-bind="$attrs">
            <template v-if="text">{{text}}</template>
            <slot v-else></slot>
        </el-button>
    </a>
    <el-button
        :type="type"
        :disabled="disabled"
        :size="size"
        v-bind="$attrs"
        v-else
        @click="click"
        class="xx-link"
    >
        <template v-if="text">{{text}}</template>
        <slot v-else></slot>
    </el-button>
</template>

<script>
export default {
    name: 'XxLink',
    props: {
        path: {
            type: [String, Object],
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        params: {
            type: Object,
            default: () => ({}),
        },
        href: {
            type: String,
        },
        target: {
            type: String,
            default: '_blank',
        },
        // a 标签 rel="noreferrer"
        rel: {
            type: String,
        },
        download: {
            type: [Boolean, String],
            default: '',
        },
        type: {
            type: String,
            default: 'text', // primary / success / warning / danger / info / text
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        _href() {
            if (this.href) {
                return this.href;
            }

            const { path, params } = this;
            const { isObject, stringifyUrl } = this.$tools;
            const { urlPrefix } = process.env.projectConfig;
            // TODO: 后续废弃底层添加 .html 操作，业务层自己添加
            if (isObject(path)) {
                const { url, params } = path;
                // [/supplier or /supplier-alias] => /supplier
                if (url.startsWith('/') && !url.startsWith(urlPrefix.replace(/\/([a-zA-Z]+)-alias/, '/$1'))) {
                    return stringifyUrl(`${urlPrefix}${url}.html`, params);
                }
                return stringifyUrl(`${url}.html`, params);
            }
            return stringifyUrl(path, params);
        },
        hrefRes() {
            // 这里不能走 a标签 href，要走 this.$tools.linkTo
            // return this.$tools.delUrlAlias(this.$tools.getFullUrl(this._href));
            return 'javascript:;';
        },
        isLink() {
            return Boolean(this.path || this.href);
        },
        size() {
            const { type, $attrs } = this;
            return $attrs.size || (type === 'text' ? 'medium' : '');
        },
    },
    methods: {
        click(e) {
            if (this.disabled || this.isLink) {
                e.preventDefault();
            }
            if (!this.disabled && this.isLink) {
                this.$tools.linkTo(
                    this.$tools.delUrlAlias(this.$tools.getFullUrl(this._href)),
                    {},
                    {
                        target: this.target,
                        rel: this.rel,
                        download: this.download,
                    }
                );
            }
            this.$emit('click');
            // e.preventDefault(); // TODO: 待更新不当用法后再打开。举例：<xx-link native-type="submit" type="primary">查询</xx-link>
        },
    },
};
</script>

<style lang="scss" scoped>
.xx-link:not(:first-child) {
    margin-left: 10px;
}
.xx-link {
    &.el-button--text,
    .el-button--text {
        user-select: text;
    }
}
</style>
